<template>
  <div class="scroll-section" id="jobs">
    <div class="section-bg" :style="'background-image: url(' + section_bg + ');'"></div>
    <div class="container">
      <div class="columns">
        <div class="column is-three-quarters-widescreen is-half-tablet">
          <h1 class="positions-header"><strong>{{ $t('positions.headline') }}</strong></h1>
          <div class="positions-copy" v-html="$t('positions.paragraph')"></div>
          <div class="positions-available" v-if="$t('positions.jobs').length > 0">
            <h3>{{ $t('positions.jobs_header') }}</h3>
            <div class="positions-available-list" v-for="(job, i) in $t('positions.jobs')" :key="job.title">
              <div class="job-icon">

                <svg width="512px" height="437px" viewBox="0 0 512 437" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Page-1">
                    <g id="business-and-finance">
                      <path d="M256,75.5 L256,176.044766" id="Line" stroke="#000000" stroke-width="32"
                        stroke-linecap="square"></path>
                      <path
                        d="M296.75,40.75 C296.75,63.257812 278.507812,81.503906 256,81.503906 L255.832031,81.503906 C233.398438,81.40625 215.25,63.207031 215.25,40.75 C215.25,18.296875 233.398438,0.09375 255.832031,0 L256,0 C278.507812,0 296.75,18.242188 296.75,40.75 Z"
                        id="job-inner-1" fill="#A94350"></path>
                      <path
                        d="M512,219.4375 L512,408.972656 C512,424.082031 499.753906,436.328125 484.65625,436.328125 L27.34375,436.328125 C12.246094,436.328125 0,424.082031 0,408.972656 L0,219.4375 C0,204.339844 12.246094,192.09375 27.34375,192.09375 L484.65625,192.09375 C499.753906,192.09375 512,204.339844 512,219.4375 L512,219.4375 Z"
                        id="Shape" fill="#3D5B85"></path>
                      <path
                        d="M512,219.4375 L512,408.972656 C512,424.082031 499.753906,436.328125 484.65625,436.328125 L256,436.328125 L256,192.09375 L484.65625,192.09375 C499.753906,192.09375 512,204.339844 512,219.4375 Z"
                        id="Shape" fill="#263E5F"></path>
                      <path
                        d="M376.015625,257.0625 C368.421875,257.0625 362.269531,263.214844 362.269531,270.804688 L362.269531,310.355469 L335.660156,263.96875 C332.5625,258.566406 326.222656,255.925781 320.199219,257.527344 C314.183594,259.128906 309.996094,264.578125 309.996094,270.808594 L309.996094,361.933594 C309.996094,369.523438 316.148438,375.679688 323.738281,375.679688 C331.328125,375.679688 337.484375,369.523438 337.484375,361.933594 L337.484375,322.386719 L364.09375,368.773438 C366.585938,373.121094 371.179688,375.679688 376.011719,375.679688 C377.1875,375.679688 378.375,375.527344 379.554688,375.214844 C385.570312,373.609375 389.757812,368.160156 389.757812,361.933594 L389.757812,270.804688 C389.757812,263.214844 383.605469,257.0625 376.015625,257.0625 L376.015625,257.0625 Z"
                        id="Shape" fill="#FFFFFF"></path>
                      <path
                        d="M96.144531,257.0625 C88.554688,257.0625 82.402344,263.214844 82.402344,270.804688 L82.402344,303.65625 L57.613281,303.65625 L57.613281,270.804688 C57.613281,263.214844 51.460938,257.0625 43.871094,257.0625 C36.28125,257.0625 30.128906,263.214844 30.128906,270.804688 L30.128906,361.933594 C30.128906,369.523438 36.28125,375.675781 43.871094,375.675781 C51.460938,375.675781 57.613281,369.523438 57.613281,361.933594 L57.613281,331.144531 L82.402344,331.144531 L82.402344,361.933594 C82.402344,369.523438 88.554688,375.675781 96.144531,375.675781 C103.734375,375.675781 109.890625,369.523438 109.890625,361.933594 L109.890625,270.804688 C109.886719,263.214844 103.734375,257.0625 96.144531,257.0625 L96.144531,257.0625 Z"
                        id="Shape" fill="#FFFFFF"></path>
                      <path
                        d="M212.6875,257.0625 L183.804688,257.0625 C176.214844,257.0625 170.0625,263.214844 170.0625,270.804688 L170.0625,361.476562 C170.0625,369.046875 175.980469,375.535156 183.546875,375.675781 C191.257812,375.816406 197.550781,369.609375 197.550781,361.933594 L197.550781,328.324219 L208.289062,328.324219 L223.269531,366.910156 C225.378906,372.351562 230.578125,375.679688 236.082031,375.679688 C237.734375,375.679688 239.417969,375.378906 241.054688,374.746094 C248.128906,372 251.640625,364.039062 248.890625,356.960938 L235.347656,322.070312 C244.09375,315.886719 249.824219,305.703125 249.824219,294.199219 C249.824219,273.6875 233.195312,257.0625 212.6875,257.0625 L212.6875,257.0625 Z M197.550781,284.546875 L214.195312,284.546875 C218.691406,284.546875 222.335938,288.195312 222.335938,292.691406 C222.335938,297.1875 218.691406,300.835938 214.195312,300.835938 L197.550781,300.835938 L197.550781,284.546875 Z"
                        id="Shape" fill="#FFFFFF"></path>
                      <path
                        d="M472.65625,311.820312 L454.699219,311.820312 C447.109375,311.820312 440.957031,317.972656 440.957031,325.5625 C440.957031,333.152344 447.109375,339.308594 454.699219,339.308594 L458.914062,339.308594 L458.914062,345.628906 C458.914062,347.21875 457.980469,348.191406 457.46875,348.191406 L435.570312,348.191406 C435.058594,348.191406 434.125,347.21875 434.125,345.628906 L434.125,287.113281 C434.125,285.523438 435.058594,284.550781 435.570312,284.550781 L457.46875,284.550781 C457.980469,284.550781 458.914062,285.523438 458.914062,287.113281 C458.914062,294.703125 465.066406,300.859375 472.65625,300.859375 C480.246094,300.859375 486.398438,294.703125 486.398438,287.113281 C486.398438,270.542969 473.421875,257.0625 457.472656,257.0625 L435.570312,257.0625 C419.617188,257.0625 406.640625,270.542969 406.640625,287.113281 L406.640625,345.628906 C406.640625,362.195312 419.617188,375.675781 435.570312,375.675781 L457.472656,375.675781 C473.421875,375.675781 486.398438,362.195312 486.398438,345.628906 L486.398438,325.5625 C486.398438,317.972656 480.246094,311.820312 472.65625,311.820312 L472.65625,311.820312 Z"
                        id="Shape" fill="#FFFFFF"></path>
                      <path
                        d="M279.910156,257.0625 C272.320312,257.0625 266.164062,263.214844 266.164062,270.804688 L266.164062,361.933594 C266.164062,369.523438 272.320312,375.675781 279.910156,375.675781 C287.5,375.675781 293.652344,369.523438 293.652344,361.933594 L293.652344,270.804688 C293.652344,263.214844 287.5,257.0625 279.910156,257.0625 L279.910156,257.0625 Z"
                        id="Shape" fill="#FFFFFF"></path>
                      <path
                        d="M139.976562,257.0625 C132.386719,257.0625 126.230469,263.214844 126.230469,270.804688 L126.230469,361.933594 C126.230469,369.523438 132.386719,375.675781 139.976562,375.675781 C147.566406,375.675781 153.71875,369.523438 153.71875,361.933594 L153.71875,270.804688 C153.71875,263.214844 147.566406,257.0625 139.976562,257.0625 L139.976562,257.0625 Z"
                        id="Shape" fill="#FFFFFF"></path>
                    </g>
                  </g>
                </svg>

              </div>
              <div class="job-title">
                {{ $t('positions.jobs[' + i + ']').title }}
              </div>
              <div class="job-body" v-html="$t('positions.jobs[' + i + ']').body"></div>
            </div>
          </div>
          <h1 class="positions-list-header">{{ $t('positions.list_header') }}</h1>
          <ul class="positions-list">
            <li v-for="n in 5" v-html="$t('positions.list[' + (n - 1) + ']')" :key="n"></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="envelope animate">
      <div class="envelope-flap" :style="'background-image: url(' + envelope_flap_bg + ');'"></div>
      <div class="envelope-letter animate">
        <img :src="imgYourFaceHere">
        <p>{{ $t('positions.letter_copy') }}</p>
      </div>
      <div class="envelope-main" :style="'background-image: url(' + envelope_main_bg + ');'"></div>
      <a class="mailto-btn animate" :href="'mailto:' + recipient">Email</a>
    </div>
  </div>
</template>
<script>

import { detectLocale } from '../../multilanguage/locale.js';

import emailImgDA from '../.././assets/email-img-da.png';
import emailImgEN from '../.././assets/email-img-en.png';

import positionsBg from '../.././assets/positions-bg-optimized.png'

import envelopeFlapBg from '../.././assets/envelope-bottom-optimized.png'
import envelopeMainBg from '../.././assets/envelope-top-optimized.png'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Positions',
  data() {
    return {
      exclude_from_nav: false,
      nav_title: 'vacant_positions',
      section_bg: positionsBg,
      envelope_flap_bg: envelopeFlapBg,
      envelope_main_bg: envelopeMainBg,
      recipient: 'info@onlinecity.io'
    }
  },
  mounted() {
    this.hideElements()
  },
  watch: {
    active_section_name(val) {
      if (val === this.$options._componentTag) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations()
        }
      }
    },
    scroll_pos(val) {
      if (this.scroll_pos > (this.$el.offsetTop - 200) && this.scroll_pos < ((this.elHeight - 200) + this.$el.offsetTop)) {
        if (!this.is_animating_scroll) {
          this.setActiveSection(this.$options._componentTag)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      active_section_name: 'getActiveSectionName',
      scroll_pos: 'getScrollPos',
      is_animating_scroll: 'getAnimatingScrollState'
    }),
    elHeight() {
      return Math.ceil(this.$el.getBoundingClientRect().height)
    },
    imgYourFaceHere() {
      if (this.$store.state.locale === 'da') {
        return emailImgDA;
      } else {
        return emailImgEN;
      }
    }
  },
  methods: {
    ...mapActions([
      'setActiveSection'
    ]),
    hideElements() {
      if (window.ieLegacy()) {
        return;
      }
      let elements = this.$el.querySelectorAll('.animate')
      TweenMax.set(elements, {
        autoAlpha: 0
      })
    },
    runSectionAnimations() {

      if (window.ieLegacy()) {
        return;
      }

      if (this.animationsInit) return
      let envelope = this.$el.querySelector('.envelope')
      let letter = this.$el.querySelector('.envelope-letter')
      let btn = this.$el.querySelector('.mailto-btn')
      TweenMax.to(envelope, 0.3, {
        autoAlpha: 1
      })
      TweenMax.fromTo(envelope, 0.8, {
        y: 300
      }, {
        y: 0,
        ease: Power2.easeInOut
      })
      TweenMax.to(letter, 0.3, {
        autoAlpha: 1,
        delay: 0.9,
        ease: Power3.easeInOut
      })
      TweenMax.fromTo(letter, 0.8, {
        y: 300
      }, {
        y: 0,
        delay: 1,
        ease: Power1.easeInOut
      })
      TweenMax.to(btn, 0.3, {
        autoAlpha: 1,
        delay: 1.7
      })
      this.animationsInit = true
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-section {
  padding-top: 55px;
  padding-bottom: 55px;
  background-color: white;
  position: relative;
  overflow-x: hidden;
  z-index: 1;
}

@media screen and (max-width: 1024px) {
  .container {
    padding: 0 1.2rem;
  }
}

@media screen and (max-width: 768px) {
  .container {
    margin-bottom: 420px;
  }
}
</style>

<style lang="scss">
.section-bg {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 933px;
  background-position: bottom left;

  @media screen and (max-width: 1024px) {
    background-size: 590px;
  }
}

.positions-header {
  text-transform: uppercase;
  font-size: 2.5rem;

  strong {
    color: #122360;
  }

  @media screen and (max-width: 768px) {
    font-size: 1.6rem;
  }
}

.positions-copy {
  padding-right: 15%;
  margin: 0;
  padding-bottom: 0;

  p {
    line-height: 2rem;
    margin-bottom: 0rem;

    +p {
      margin-bottom: 1.7rem;
    }
  }
}

.positions-available {

  @keyframes job-icon-spin-head {
    0% {
      transform: rotateZ(15deg);
    }

    50% {
      transform: rotateZ(-15deg);
    }

    100% {
      transform: rotateZ(15deg);
    }
  }

  @keyframes job-icon-spin {
    0% {
      transform: rotateZ(-20deg);
    }

    50% {
      transform: rotateZ(20deg);
    }

    100% {
      transform: rotateZ(-20deg);
    }
  }

  margin: 1rem 0 1.5rem 2rem;
  position: relative;

  padding-left: 17px;

  .positions-available-list {

    display: block;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: auto;

    margin-bottom: 16px;

    &:before {
      width: 34px;
      height: 34px;
      content: "";
      display: block;
      position: absolute;
      top: 30px;
      left: -50px;
      background-size: 100%;

      transform: translateY(-50%);
      background-image: url('../.././assets/logo-mascot-1.png');
      z-index: 2;

      margin-top: -30px;

      animation-name: job-icon-spin-head;
      animation-delay: 0s;
      animation-duration: 2s;
      animation-iteration-count: infinite;
      animation-direction: normal;
      animation-fill-mode: both;
      animation-play-state: running;
      animation-timing-function: ease-in-out;

      box-shadow: 0px 10px 3px rgba(255, 255, 255, 0.25);
      border-radius: 100%;

    }
  }

  h3 {
    font-size: 1em;
    font-weight: 700;
    margin: 0 0 .2em 0;
    font-style: italic;
    display: none;
  }

  .job-icon {
    width: 40px;
    height: 40px;
    display: block;
    float: left;
    position: absolute;
    left: -54px;
    top: 20px;
    background: transparent;
    opacity: 1;
    z-index: 1;
    shape-rendering: geometricPrecision;

    animation-name: job-icon-spin;
    animation-delay: 0s;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-direction: normal;
    animation-fill-mode: both;
    animation-play-state: running;
    animation-timing-function: ease-in-out;

    svg {
      width: 100%;
      height: 100%;
      //transform: scale(0.1111);

      &,
      * {
        shape-rendering: geometricPrecision;
      }

      path#job-inner-1,
      path#job-inner-2 {
        //fill: rgba(255, 255, 255, 0.5);
        fill: none;
        opacity: 0;
      }
    }
  }

  .job-title {
    color: #ff723e;
    font-weight: 700;
    font-size: 1.2em;
  }

  .job-body {
    a {
      color: #ff7c4e;
      text-decoration: none;
      border-bottom: 1px solid #ff7c4e;
    }
  }
}

.positions-list-header {
  color: #ff723e;
  font-size: 3.8rem;
  line-height: 1.2;
  font-family: 'angelique_roseregular';

  @media screen and (max-width: 768px) {
    font-size: 2.5rem;
  }

  margin-bottom: 20px;
}

.positions-list {
  >li {
    position: relative;
    padding-left: 50px;
    margin-top: .2em;
    margin-bottom: .2em;
    height: auto;
    //min-height: 40px;
    width: 100%;
    //max-width: 300px;
    min-height: 34px;
    line-height: 2.1;
    vertical-align: middle;
    display: inline-block;
    white-space: normal;
    word-break: normal;
    word-wrap: normal;

    clear: both;

    &:before {
      width: 34px;
      height: 34px;
      content: "";
      display: block;
      position: absolute;
      left: 0;
      background-size: 100%;
      top: 50%;
      transform: translateY(-50%);
    }

    @media screen and (min-width: 900px) {}

  }

  >li:nth-child(1):before {
    background-image: url('../.././assets/logo-mascot-1.png');
  }

  >li:nth-child(2):before {
    background-image: url('../.././assets/logo-mascot-2.png');
  }

  >li:nth-child(3):before {
    background-image: url('../.././assets/logo-mascot-3.png');
  }

  >li:nth-child(4):before {
    background-image: url('../.././assets/logo-mascot-4.png');
  }

  >li:nth-child(5):before {
    background-image: url('../.././assets/logo-mascot-5.png');
  }
}

.envelope {
  width: 530px;
  height: 340px;
  position: absolute;
  right: -40px;
  bottom: -120px;

  @media screen and (max-width: 768px) {
    width: 60%;
    right: 5%;
    bottom: -20%;
  }

  @media screen and (max-width: 480px) {
    width: 90%;
    right: 5%;
    bottom: -15%;
  }

  .envelope-flap,
  .envelope-main {
    background-size: 100%;
    background-repeat: no-repeat;
    width: 100%;
    position: absolute;
    top: 0;
  }

  .envelope-flap {
    top: -206px;
    z-index: 1;
    padding-bottom: 81.09%;

    @media screen and (max-width: 768px) {
      top: auto;
      bottom: 44%;
    }

    @media screen and (max-width: 480px) {
      top: auto;
      bottom: 59%;
    }
  }

  .envelope-main {
    z-index: 3;
    padding-bottom: 64.1580%;
  }

  .envelope-letter {
    width: 88%;
    left: 6%;
    top: -320px;
    padding: 0 20px;
    padding-top: 35px;
    padding-bottom: 200px;
    position: absolute;
    z-index: 2;
    background-color: #f8f8f8;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);

    >img {
      width: 46%;
      margin-bottom: 40px;

      @media screen and (max-width: 768px) {
        margin-bottom: 20px;
      }
    }
  }

  .mailto-btn {
    padding: .1rem 2.5rem;
    background-color: transparent;
    border: 2px solid #ff7c4e;
    text-transform: uppercase;
    color: #ff7c4e;
    font-weight: 700;
    font-size: 1.5rem;
    position: absolute;
    z-index: 4;
    left: 50%;
    top: 30px;
    transition: all .15s ease;
    transform: translateX(-50%);
    backface-visibility: hidden;

    &:hover {
      transform: translateX(-50%) scale(1.1);
    }

    @media screen and (max-width: 768px) {
      padding: 2px 20px;
      font-size: 1.2rem;
      top: 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/sections/Positions.vue